import sportsIcon from "../assets/imagesNew/icon-sport.webp";
import casinoIcon from "../assets/imagesNew/icon-casino.webp";
import slotIcon from "../assets/imagesNew/icon-slot.webp";
import TableIcon from "../assets/imagesNew/icon-table.webp";
 import fishicon from "../assets/imagesNew/icon-fish.webp";
import crashIcon from "../assets/imagesNew/icon-crash.webp";
import lotteryIcon from "../assets/imagesNew/icon-lottery.webp";
import arcadeIcon from "../assets/imagesNew/icon-arcade.webp";

import withdrawIcon from "../assets/imagesNew/withdraw.webp";
import DepositIcon from "../assets/imagesNew/money.webp";
import liveCasino1 from "../assets/imagesNew/live_casino1.webp";
import liveCasino2 from "../assets/imagesNew/live_casino2.webp";
import bannerSlider1 from "../assets/imagesNew/banner-slider1.webp";
import bannerSlider2 from "../assets/imagesNew/banner-slider2.webp";

import feature1 from "../assets/imagesNew/feature1.webp";
import feature2 from "../assets/imagesNew/feature2.webp";
import feature3 from "../assets/imagesNew/feature3.webp";
import feature4 from "../assets/imagesNew/feature4.webp";
import feature5 from "../assets/imagesNew/feature5.webp";
import feature6 from "../assets/imagesNew/feature6.webp";
import feature7 from "../assets/imagesNew/feature7.webp";

import jilliIcon from "../assets/imagesNew/jilli.webp";
import Jili from "../assets/imagesNew/jilii.webp";
import esport from "../assets/images/E1SPORT.webp";
import cashRocket from "../assets/images/cash-rocket.webp";
import sevenupsevendown from "../assets/images/7up7down.webp";
import sicbo from "../assets/images/sicbo.webp";
import btg from "../assets/images/btg.webp";
import f1 from "../assets/images/feature-1.webp";
import f2 from "../assets/images/feature-2.webp";

import hotIcon from "../assets/images/icon-hot.gif";

import loginBanner1 from "../assets/images/login-banner1.webp";
import loginBanner2 from "../assets/images/login-banner2.webp";
import loginBanner3 from "../assets/images/login-banner3.webp";

import iconExchange from "../assets/images/icon-exchange.webp";
import iconSportbook from "../assets/images/icon-sportbook.webp";
import iconHorsebook from "../assets/images/horse-racing.svg";
import velkieLogo from "../assets/images/logo-velki.svg";

import iconsbtech from "../assets/images/icon-sbtech.webp";
import iconawcmbc from "../assets/images/icon-awcmbc.webp";
import iconkabaddi from "../assets/images/icon-kabaddi.webp";
import iconhotroad from "../assets/images/hotroad.webp";

import fc from "../assets/images/fc.webp";
import jdb from "../assets/images/jdb.webp";
import km from "../assets/images/km.webp";
import ludo from "../assets/images/LUDO.webp";
import pg from "../assets/images/pg.webp";
import pt from "../assets/images/pt.webp";
import ps from "../assets/images/provider-ps.webp";
import rt from "../assets/images/REDTIGER.webp";
import sexy from "../assets/images/SEXYBCRT.webp";
import sg from "../assets/images/SPADEGAMING.webp";
import venus from "../assets/images/venus.webp";
import evo from "../assets/images/evo.webp";
import sv388 from "../assets/images/SV388.webp";
import pp from "../assets/images/pp.webp";
import yl from "../assets/images/YL.webp";
import yesbingo from "../assets/images/provider-awcmyesbingo.webp";
import rich88 from "../assets/images/provider-rich88.webp";
import ka from "../assets/images/provider-ka.webp";
import cq9 from "../assets/images/provider-cq9.webp";
import netent from "../assets/images/provider-netent.webp";
import nlcLogo from "../assets/images/nl-yellow.svg";

import worldmatch from "../assets/images/provider-worldmatch.webp";
import fastspin from "../assets/images/FASTSPIN.webp";
import joker from "../assets/images/provider-joker.webp";
import p8 from "../assets/images/provider-awcmp8.webp";
import png from "../assets/images/provider-playngo.webp";
import bpoker from "../assets/images/provider-bpoker.webp";
import number from "../assets/images/provider-number.webp";
import dragonsoft from "../assets/images/DRAGONSOFT.webp";
import biggaming from "../assets/images/BIGGAMING.webp";
import sabavrtual from "../assets/images/SABAVIRTUAL.webp";
import ezugi from "../assets/images/EZUGI.webp";
import superspade from "../assets/images/SUPERSPADE.webp";
import evoplay from "../assets/images/EVOPLAY.webp";
import onetouch from "../assets/images/ONETOUCH.webp";
import spribe from "../assets/images/SPRIBE.webp";
import bombaylive from "../assets/images/BOMBAYLIVE.webp";
import royalgaming from "../assets/images/ROYALGAMING.webp";
import sabasport from "../assets/images/saba-sport.webp";

import evoNew from "../assets/images/evolution.webp";
import ezugiNew from "../assets/images/evolution-new.webp";
import jiliNew from "../assets/images/jililobby.webp";
import pragmaticNew from "../assets/images/pragmatic-play.webp";
import aeSexy from "../assets/images/aeSexy.webp";
import horseRacing from "../assets/images/horse-racing.gif";
import ptNew from "../assets/images/ptNew.webp";
import betgames from "../assets/images/BETGAMES.webp";

import fav1 from "../assets/images/fav1.webp";
import fav2 from "../assets/images/fav2.webp";
import fav3 from "../assets/images/fav3.webp";
import fav4 from "../assets/images/fav4.webp";

import pakistanFlag from "../assets/images/flag-symbolism-Pakistan-design-Islamic.webp";
import camodiaFlag from "../assets/images/Flag-Cambodia.webp";
import philippinesFlag from "../assets/images/Flag_of_philippines.svg.webp";
import brazilFlag from "../assets/images/Flag_of_Brazil.svg.webp";
import indiaFlag from "../assets/images/Flag_of_India.svg.webp";
import bangladeshFlag from "../assets/images/Flag_of_Bangladesh.svg.webp";
// hotgame Image
import pmegasicbo from "../assets/images/hot-casino/pmegasicbo.webp";
import pmegawheel from "../assets/images/hot-casino/pmegawheel.webp";
import pmegaroll from "../assets/images/hot-casino/pmegaroll.webp";
import pbaccarat from "../assets/images/hot-casino/pbaccarat.webp";
import pdt from "../assets/images/hot-casino/pdt.webp";
import ppsicbo from "../assets/images/hot-casino/ppsicbo.webp";
import pthilo from "../assets/images/hot-casino/pthilo.webp";
import ptspinwin from "../assets/images/hot-casino/ptspinwin.webp";
import playtechteenpatti from "../assets/images/hot-casino/playtech-teen-patti.webp";
import bgroll from "../assets/images/hot-casino/bgroll.webp";
import bgsicbo from "../assets/images/hot-casino/bgsicbo.webp";
import bgspeedsicbo from "../assets/images/hot-casino/bgspeedsicbo.webp";
import pcrazytime from "../assets/images/hot-casino/pcrazytime.webp";
import pmonopoly from "../assets/images/hot-casino/pmonopoly.webp";
import pcoinflip from "../assets/images/hot-casino/pcoinflip.webp";
import evoteenpatti from "../assets/images/hot-casino/evoteenpatti.webp";
import evosupersicbo from "../assets/images/hot-casino/evosupersicbo.webp";
import evospeedroullete from "../assets/images/hot-casino/evospeedroullete.webp";
import evolightdice from "../assets/images/hot-casino/evolightdice.webp";
import evoligtroullete from "../assets/images/hot-casino/evoligtroullete.webp";
import ppbacarrat2 from "../assets/images/hot-casino/ppbacarrat2.webp";

import hotgame028 from "../assets/images/hot-casino/KM-TABLE-028.webp";
import hotgame035 from "../assets/images/hot-casino/JILI-TABLE-035.webp";
import hotgame030 from "../assets/images/hot-casino/JILI-TABLE-030.webp";
import hotgame060 from "../assets/images/hot-casino/KM-TABLE-060.webp";

import hotgame047 from "../assets/images/hot-casino/JILI-TABLE-047.webp";
import hotgame015 from "../assets/images/hot-casino/KM-TABLE-015.webp";
import hotgame021 from "../assets/images/hot-casino/KM-TABLE-021.webp";
import hotgame022 from "../assets/images/hot-casino/KM-TABLE-022.webp";
import pgdragon from "../assets/images/hot-casino/pgdragon.webp";
import aviator from "../assets/images/hot-casino/aviator.webp";
//casino category

import casinolive from "../assets/images/casinolive.svg";
import casinoslot from "../assets/images/casinoslot.svg";
import casinoesports from "../assets/images/casinoesports.svg";
import casinofishing from "../assets/images/casinofishing.svg";
import casinoegame from "../assets/images/casinoegame.svg";
import casinotable from "../assets/images/casinotable.svg";
import casinovirtual from "../assets/images/casinovirtual.svg";
import casinolotto from "../assets/images/casinolotto.svg";
import casinobingo from "../assets/images/casinobingo.svg";
import casinocrash from "../assets/images/casinocrash.svg";
import casinogameshow from "../assets/images/casinogameshow.svg";

import popular1 from "../assets/images/popular-casino/crazytime.webp";
import popular2 from "../assets/images/popular-casino/supersicbo.webp";
import popular3 from "../assets/images/popular-casino/funkytime.webp";
import popular4 from "../assets/images/popular-casino/andarbahar.webp";
import popular5 from "../assets/images/popular-casino/cointoss.webp";
import popular6 from "../assets/images/popular-casino/dragontiger.webp";
import popular7 from "../assets/images/popular-casino/7up7down.webp";
import popular8 from "../assets/images/popular-casino/aviator.webp";
import popular9 from "../assets/images/popular-casino/crazycoinflip.webp";
import popular10 from "../assets/images/popular-casino/lightingroulette.webp";
import popular11 from "../assets/images/popular-casino/monopoly.webp";

import jdbIcon from "../assets/imagesNew/jdb.webp";
import superAce from "../assets/imagesNew/superace.webp";
import moneyComing from "../assets/imagesNew/moneycoming.webp";
import fortuneGems from "../assets/imagesNew/fortune-gems.webp";

import ppIcon from "../assets/imagesNew/pp.webp";
import spadeIcon from "../assets/imagesNew/spade.webp";
import an1 from "../assets/images/first.webp";
import an2 from "../assets/images/second.webp";

const obj = {
  user_status: {
    owner: "OW",
    sub_owner: "SOW",
    super_admin: "SUA",
    admin: "AD",
    sub_admin: "SAD",
    senior_super: "SSM",
    super_agent: "SA",
    agent: "AG",
    user: "CL",
  },
  user_next_status: {
    owner: "sub_owner",
    sub_owner: "super_admin",
    super_admin: "admin",
    admin: "sub_admin",
    sub_admin: "senior_super",
    senior_super: "super_agent",
    super_agent: "agent",
    agent: "user",
  },
  market_category: {
    1: "Market",
    3: "Bookmakers",
    5: "ManualOdds",
    10: "Win Toss",
    2: "Session",
    6: "Over by Over Session Market",
    7: "Player",
    9: "Wicket",
    11: "Bowler Session",
    8: "Last Digit ODD",
    4: "LineMarket",
    14: "Premium ODDs",
  },
  betCheckObj: {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  },
  matchType: {
    cricket: "Cricket",
    tennis: "Tennis",
    soccer: "Soccer",
    casino: "Casino",
  },
};
export default obj;
export const priceFormat = (value) => {
  return new Intl.NumberFormat().format(value);
};
export const LoginBanner = [
  { id: 1, banner: loginBanner1 },
  { id: 2, banner: loginBanner2 },
  { id: 3, banner: loginBanner3 },
];
export const CountryFlagBanner = [
  { id: 1, banner: pakistanFlag, title: "Pakistan" },
  { id: 2, banner: camodiaFlag, title: "camodia" },
  { id: 3, banner: philippinesFlag, title: "philippines" },
  { id: 4, banner: brazilFlag, title: "brazil" },
  { id: 5, banner: indiaFlag, title: "india" },
  { id: 6, banner: bangladeshFlag, title: "bangladesh" },
];

export const PopularCasino = [
  {
    id: 1,
    icons: popular1,
    title: "Crazy Time",
    titlebn: "ক্রেজি টাইম",
    gameTypeCheck: "platForm",
    gameType: "LIVE",
    platForm: "EVOLUTION",
    casinoType: "EVOLUTION-LIVE-006",
  },
  {
    id: 1,
    icons: popular2,
    title: "Super Sic Bo",
    titlebn: "সুপার সিকবো",
    gameTypeCheck: "platForm",
    gameType: "LIVE",
    platForm: "EVOLUTION",
    casinoType: "EVOLUTION-LIVE-005",
  },
  {
    id: 3,
    icons: popular3,
    title: "Funky Time",
    titlebn: "ফানকি টাইম",
    gameTypeCheck: "platForm",
    gameType: "LIVE",
    platForm: "EVOLUTION",
    casinoType: "EVOLUTION-LIVE-183",
  },
  {
    id: 4,
    icons: popular4,
    title: "Andar Bahar",
    titlebn: "আন্দার বাহার",
    gameTypeCheck: "platForm",
    gameType: "TABLE",
    platForm: "JILI",
    casinoType: "JILI-TABLE-003",
  },
  {
    id: 5,
    icons: popular5,
    title: "Coin Toss",
    titlebn: "কয়েন টস",
    gameTypeCheck: "platForm",
    gameType: "TABLE",
    platForm: "KINGMAKER",
    casinoType: "KM-TABLE-036",
  },
  {
    id: 6,
    icons: popular6,
    title: "Dragon Tiger",
    titlebn: "ড্রাগন টাইগার",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-034",
  },
  {
    id: 7,
    icons: popular7,
    title: "7up7down",
    titlebn: "৭ আপ ৭ ডাউন",
    gameTypeCheck: "platForm",
    gameType: "TABLE",
    platForm: "JILI",
    casinoType: "JILI-TABLE-011",
  },
  {
    id: 8,
    icons: popular8,
    title: "Aviatar ",
    titlebn: "অ্যাভায়টর",
    gameTypeCheck: "platForm",
    gameType: "",
    platForm: "",
    casinoType: "",
  },
  {
    id: 9,
    icons: popular9,
    title: "Crazy Coin Flip",
    titlebn: "ক্রেজি কয়েন ফ্লিপ",
    gameTypeCheck: "platForm",
    gameType: "LIVE",
    platForm: "EVOLUTION",
    casinoType: "EVOLUTION-LIVE-014",
  },
  {
    id: 10,
    icons: popular10,
    title: "Lightning Roulette",
    titlebn: "লাইটেনিং রোলেট",
    gameTypeCheck: "platForm",
    gameType: "LIVE",
    platForm: "EVOLUTION",
    casinoType: "EVOLUTION-LIVE-040",
  },
  {
    id: 11,
    icons: popular11,
    title: "MONOPOLY",
    titlebn: "মনোপলি",
    gameTypeCheck: "platForm",
    gameType: "LIVE",
    platForm: "EVOLUTION",
    casinoType: "EVOLUTION-LIVE-006",
  },
];
export const BannerSliderData = [
  { id: 1, bannerImg: an1 },
   { id: 2, bannerImg: an2 },
  //  { id:3, bannerImg: an3 },
  //   { id:4, bannerImg: an4 },
];
export const SlotData = [
  {
    id: 2,
    icons: superAce,
    title: "Super Ace",
    titlebn: "সুপার এইস",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-027",
  },
  {
    id: 2,
    icons: moneyComing,
    title: "Money Coming",
    titlebn: "মানি কামিং",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-029",
  },
  {
    id: 2,
    icons: fortuneGems,
    title: "fortune Gems",
    titlebn: "ফরচুন গেমস",
    gameTypeCheck: "platForm",
    gameType: "SLOT",
    platForm: "JILI",
    casinoType: "JILI-SLOT-043",
  },
  {
    id: 2,
    icons: jdbIcon,
    title: "JDB",
    titlebn: "জেডিবি",
    key: "SLOT",
    gameType: "SLOT",
    platForm: "JDB",
  },
  {
    id: 3,
    icons: jilliIcon,
    title: "JILI",
    titlebn: "ঝিলি",
    key: "SLOT",
    gameType: "SLOT",
    platForm: "JILI",
  },
  {
    id: 4,
    icons: ppIcon,
    title: "PP",
    titlebn: "প্যারাগমেটিক প্লে",
    key: "SLOT",
    gameType: "SLOT",
    platForm: "PP",
  },
  {
    id: 5,
    icons: spadeIcon,
    title: "SPADE",
    titlebn: "স্পেডি",
    key: "SLOT",
    gameType: "SLOT",
    platForm: "SPADE",
  },
  {
    id: 6,
    icons: evoNew,
    title: "EVO",
    titlebn: "এভোলেশন",
    key: "LIVE",
    gameType: "LIVE",
    platForm: "EVOLUTION",
    casinoType: "",
  },
];

export const TableEgameData = [
  {
    id: 1,
    icons: fav1,
    link: "",
  },
  {
    id: 2,
    icons: fav2,
    link: "",
  },
  {
    id: 3,
    icons: fav3,
    link: "",
  },
  {
    id: 3,
    icons: fav4,
    link: "",
  },
];
export const DepositWithrawDataNew = [
  {
    id: 1,
    icons: DepositIcon,
    title: "Deposit",
    link: "/deposit",
    titlebn: "জমা",
  },
  {
    id: 2,
    icons: withdrawIcon,
    title: "Withdraw",
    link: "/withdraw",
    titlebn: "প্রত্যাহার করুন",
  },
];
export const DepositWithrawData = [
  {
    id: 1,
    icons: '#nav-hot_0b8ae9aa',
    title: "Hot Games",
    type: "hotgame",
    titlebn: "গরম খেল",
  },
   {
    id: 1,
    icons: "#nav-sport_e2fbf0a4",
    title: "Sports",
    type: "sports",
    titlebn: "স্পোর্টস",
    position: "translate(5px, -7px)",
  },

  // {
  //   id: 1,
  //   icons: "#nav-fav_fc2e4b64",
  //   title: "Favorites",
  //   type: "hotgame",
  //   titlebn: "গরম খেল",
  // },
   {
    id: 2,
    icons: "#nav-live_319534a6",
    title: "Live Casino",
    titlebn: "ক্যাসিনো",
    type: "live",
    position: "translate(-5px, 2px)",
    subCategory:"SEXY"
  },
   {
    id: 3,
    icons: "#nav-slot_86963cca",
    title: "Slot",
    titlebn: "স্লট",
    type: "slot",
    position: "translate(-1px, -7px)",
    subCategory:"JILI"
  },
  // {
  //   id: 4,
  //   icons: "#nav-pvp_c10cd04b",
  //   title: "Table",
  //   titlebn: "টেবিল",
  //   type: "table",
  //   position: "translate(-9px, 3px)",
  // },
   
     {
    id: 2,
    icons: "#nav-pvp_c10cd04b",
    title: "Poker",
    titlebn: "ক্যাসিনো",
    type: "poker",
    position: "translate(-5px, 2px)",
    subCategory:"JILI"
  },
   {
    id: 5,
    icons: "#nav-fish_59aa682d",
    title: "Fishing",
    titlebn: "মাছ ধরা",
    type: "fishing",
    position:'translate(-4px, -5px)',
     subCategory:"JILI"
  },
 
 
  // {
  //   id: 6,
  //   icons: crashIcon,
  //   title: "Aviator",
  //   titlebn: "বৈমানিক",
  //   type: "aviator",
  //   position: "translate(-5px, 2px)",
  // },
  
  
  
  // {
  //   id: 6,
  //   icons: crashIcon,
  //   title: "Crash",
  //   titlebn: "ক্র্যাশ",
  //   type: "crash",
  //   position: "translate(-5px, 2px)",
  // },

  {
    id: 7,
    icons: "#nav-esport_f6ddcc86",
    title: "E-sports",
    type: "esports",
    titlebn: "ই-স্পোর্টস",
  },
  {
    id: 8,
    icons: "#nav-lottery_79b60d1b",
    title: "Lottery",
    titlebn: "লটারি",
    type: "lottery",
    position: "translate(-7px, 9px)",
  },
];
export const DepositWithrawDataArray = [
  {
    id: 1,
    title: "Sports",
    key: "sports",
    titlebn: "স্পোর্টস",
    array: [
      {
        image: iconExchange,
        title: "Exchange",
        gameTypeCheck: "sports",
        link: `${process.env.REACT_APP_SKY_URL}bkash/${localStorage.getItem(
          "token"
        )}`,
      },
      // {
      //   image: velkieLogo,
      //   title: "Velki",
      //   gameTypeCheck: "sports",
      //   link: `${process.env.REACT_APP_VELKIE_URL}bkash/${localStorage.getItem(
      //     "token"
      //   )}`,
      // },
      {
        image: iconsbtech,
        title: "Sportsbook BTi",
        link: "",
        gameTypeCheck: "platForm",
        platForm: "SABA",
        gameType: "VIRTUAL",
        casinoType: "SABA-VIRTUAL-001",
      },
      {
        image: iconSportbook,
        title: "Sportsbook SABA",
        link: "",
        gameTypeCheck: "platForm",
        platForm: "SABA",
        gameType: "VIRTUAL",
        casinoType: "SABA-VIRTUAL-001",
      },
      {
        image: iconawcmbc,
        title: "BC Sports",
        link: "",
        gameTypeCheck: "platForm",
        platForm: "SABA",
        gameType: "",
        casinoType: "",
        islobbyTrue: true,
      },
      {
        image: iconkabaddi,
        title: "Kabaddi",
        link: "",
        gameTypeCheck: "platForm",
        platForm: "SABA",
        gameType: "VIRTUAL",
        casinoType: "SABA-VIRTUAL-001",
      },
      {
        image: "",
        title: "",
        link: "",
        gameTypeCheck: "",
        platForm: "",
        gameType: "",
        casinoType: "",
      },
      {
        image: "",
        title: "",
        link: "",
        gameTypeCheck: "",
        platForm: "",
        gameType: "",
        casinoType: "",
      },
      {
        image: "",
        title: "",
        link: "",
        gameTypeCheck: "",
        platForm: "",
        gameType: "",
        casinoType: "",
      },
    ],
  },
  {
    id: 1,
    title: "Crash",
    key: "crash",
    titlebn: "গরম খেল",
    array: [
      {
         image: spribe,
        title: "SPRIBE",
        type: "SPRIBE",
        key: "crash",
        // gameTypeCheck: "platForm",
        platForm: "SPRIBE",
        gameType: "",
        casinoType: "",
      },
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "crash",
        // gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "JILI",
      },
      {
        image: km,
        title: "KM",
        type: "kingmaker",
        key: "crash",
        // gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "KINGMAKER",
      },
      {
        image: pp,
        title: "PP",
        type: "pp",
        key: "crash",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "PP",
      },
    ],
  },
  {
    id: 2,
    title: "Live Casino",
    key: "casino",
    titlebn: "লাইভ ক্যাসিনো",
    array: [
      {
        image: evo,
        title: "EVOLUTION",
        type: "evo",
        key: "live",
        // gameTypeCheck: "platForm",
        platForm: "EVOLUTION",
        gameType: "LIVE",
        casinoType: "EVOLUTION-LIVE-006",
        isLobbyTrue: true,
      },
      {
        image: sexy,
        title: "SEXYBCRT",
        type: "sexy",
        key: "live",
        // gameTypeCheck: "platForm",
        platForm: "SEXYBCRT",
        gameType: "LIVE",
        casinoType: "MX-LIVE-006",
        isLobbyTrue:true
      },
      // {
      //   image: Jili,
      //   title: "JILI",
      //   type: "jili",
      //   key: "live",
      //   platForm: "JILI",
      // },
      // {
      //   image: km,
      //   title: "KINGMAKER",
      //   type: "kingmaker",
      //   key: "live",
      //   gameType: "TABLE",
      //   platForm: "KINGMAKER",
      // },
      // {
      //   image: ludo,
      //   title: "LUDO",
      //   type: "ludo",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "KINGMAKER",
      //   gameType: "TABLE",
      //   casinoType: "KM-TABLE-060",
      // },
      // {
      //   image: iconHorsebook,
      //   title: "HOORSEBOOK",
      //   type: "horsebook",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "HORSEBOOK",
      //   gameType: "LIVE",
      //   casinoType: "HRB-LIVE-001",
      // },
      {
        image: iconhotroad,
        title: "HOTROAD",
        type: "hotroad",
        key: "live",
        // gameTypeCheck: "platForm",
        platForm: "HOTROAD",
        gameType: "LIVE",
        casinoType: "HOTROAD-LIVE-001",
        isLobbyTrue: true,
      },
      {
        image: pt,
        title: "PLAYTECH",
        type: "pt",
        key: "live",
        platForm: "PT",
      },
      //  {
      //   image: worldmatch,
      //   title: "WM",
      //   type: "WorldMatch",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "JDB",
      //   casinoType: "JDB-SLOT-011",
      // },
      {
        image: betgames,
        title: "BG",
        type: "bg",
        key: "live",
        // gameTypeCheck: "platForm",
        platForm: "BG",
        gameType: "LIVE",
        casinoType: "",
        
      },
      
      // {
      //   image: rt,
      //   title: "REDTIGER",
      //   type: "rt",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "RT",
      //   gameType: "SLOT",
      //   casinoType: "RT-SLOT-001",
      //   isLobbyTrue: true,
      // },
      // {
      //   image: sg,
      //   title: "SPADEGAMING",
      //   type: "spade",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "SPADE",
      //   gameType: "SLOT",
      //   casinoType: "SG-SLOT-001",
      //   isLobbyTrue: true,
      // },
      // {
      //   image: fc,
      //   title: "FC",
      //   type: "fc",
      //   key: "live",
      //   gameType: "LIVE",
      //   platForm: "FC",
      // },
      // {
      //   image: jdb,
      //   title: "JDB",
      //   type: "jdb",
      //   key: "live",
      //   gameType: "LIVE",
      //   platForm: "JDB",
      // },
      // {
      //   image: yl,
      //   title: "YL",
      //   type: "yl",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   gameType: "LIVE",
      //   platForm: "YL",
      // },
      // {
      //    image: providermg,
      //   title: "MG",
      //   type: "spade",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "SPADE",
      //   gameType: "SLOT",
      //   casinoType: "SG-SLOT-001",
      //   isLobbyTrue: true,
      // },
      
      // {
      //   image: awcmdg,
      //   title: "DG",
      //   type: "dragonsoft",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "DRAGOONSOFT",
      //   gameType: "",
      //   casinoType: "",
      // },
      {
        image: pp,
        title: "PP",
        type: "pp",
        key: "live",
        platForm: "PP",
        gameType: "LIVE",
        casinoType: "PP-LIVE-001",
      },
      

      // {
      //   image: yesbingo,
      //   title: "YESBINGO",
      //   type: "yesbingo",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "YESBINGO",
      // },

      // {
      //   image: fastspin,
      //   title: "FASTSPIN",
      //   type: "FastSpin",
      //   key: "live",

      //   gameType: "EGAME",
      //   platForm: "JDB",
      //   casinoType: "JDB-EGAME-018",
      // },
      {
        image: esport,
        title: "E1SPORT",
        type: "e1sports",
        key: "live",
        gameTypeCheck: "platForm",
        gameType: "ESPORTS",
        platForm: "E1SPORT",
        casinoType: "E1-ESPORTS-001",
      },
      // {
      //   image: biggaming,
      //   title: "BIGGAMING",
      //   type: "biggaming",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "BG",
      //   gameType: "LIVE",
      //   casinoType: "BG-LIVE-001",
      //   isLobbyTrue: true,
      // },
      // {
      //   image: pg,
      //   title: "PGSOFT",
      //   type: "pg",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "PG",
      // },

      {
        image: sv388,
        title: "SV388",
        type: "sv",
        key: "live",
        gameTypeCheck: "platForm",
        platForm: "SV388",
        gameType: "LIVE",
        casinoType: "SV-LIVE-001",
      },

      // {
      //   image: sabavrtual,
      //   title: "SABAVIRTUAL",
      //   type: "SABAVIRTUAL",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "SABA",
      //   gameType: "VIRTUAL",
      //   casinoType: "SABA-VIRTUAL-001",
      // },
      // { image: ezugi,
      //   title: "Ezugi",
      //   type: "ezugi",
      //   key: "live",
      //   gameType: "egtGame",
      //   platForm: "Ezugi",
      //   gameTypeNew: "",
      //   casinoType: "",
      // },
      // {
      //   image: superspade,
      //   title: "SUPERSPADE",
      //   type: "SUPERSPADE",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   gameType: "",
      //   platForm: "SPADE",
      //   casinoType: "",
      // },
      //  {
      //       image: evoplay,
      //       title: "EVOPLAY",
      //       type: "EVOPLAY",
      //       key: "live",
      //       gameType: "egtGame",
      //       platForm: "EVO",
      //       gameTypeNew: "",
      //       casinoType: "LIVE CASINO",
      //  },

      //  {
      //   image: onetouch,
      //   title: "ONETOUCH",
      //   type: "ONETOUCH",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "ONETOUCH",
      // },
      // {
      //   image: spribe,
      //   title: "SPRIBE",
      //   type: "SPRIBE",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "SPRIBE",
      //   gameType: "",
      //   casinoType: "",
      // },
      // {
      //   image: bombaylive,
      //   title: "SPRIBE",
      //   type: "SPRIBE",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "SPRIBE",
      // },
      // {
      //   image: royalgaming,
      //   title: "SPRIBE",
      //   type: "SPRIBE",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "SPRIBE",
      // },
    ],
  },
  
  
  {
    id: 2,
    title: "Slot",
    key: "slot",
    titlebn: "স্লট",
    array: [
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "slot",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "JILI",
      },
      {
        image: pg,
        title: "PG",
        type: "pg",
        key: "slot",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "PG",
      },
      {
        image: jdb,
        title: "JDB",
        type: "jdb",
        key: "slot",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "JDB",
      },
    //   {
    //     image: providermg,
    //    title: "MG",
    //    type: "spade",
    //    key: "slot",
    //    gameTypeCheck: "platForm",
    //    platForm: "SPADE",
    //    gameType: "SLOT",
    //    casinoType: "SG-SLOT-001",
    //    isLobbyTrue: true,
    //  },
     {
      image: fastspin,
      title: "FASTSPIN",
      type: "FastSpin",
      key: "slot",
      // gameTypeCheck: "platForm",
      gameType: "SLOT",
      platForm: "FASTSPIN",
      
    },
    // {
    //   image: providernextspin,
    //   title: "NEXTSPIN",
    //   type: "FastSpin",
    //   key: "live",
    //   gameTypeCheck: "platForm",
    //   gameType: "SLOT",
    //   platForm: "JDB",
    //   casinoType:"JDB-SLOT-031"
    // },
    {
      image: fc,
      title: "FC",
      type: "fc",
      key: "slot",
      // gameTypeCheck: "platForm",
      gameType: "SLOT",
      platForm: "FC",
    },
    {
      image: sg,
      title: "SG",
      type: "spade",
      key: "slot",
      // gameTypeCheck: "platForm",
      gameType: "SLOT",
      platForm: "SPADE",
    },
    {
      image: yesbingo,
      title: "Yes Bingo",
      type: "yesbingo",
      key: "slot",
      // gameTypeCheck: "platForm",
      gameType: "SLOT",
      platForm: "YESBINGO",
    },
    {
      image: rt,
      title: "RT",
      type: "rt",
      key: "slot",
      // gameTypeCheck: "platForm",
      gameType: "",
      platForm: "RT",
    },
    {
      image: pt,
      title: "PT",
      type: "pt",
      key: "slot",
      // gameTypeCheck: "platForm",
      gameType: "SLOT",
      platForm: "PT",
    },
      // {
      //   image: rich88,
      //   title: "RICH88",
      //   type: "RICH88",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "PP",
      //   casinoType: "PP-SLOT-001",
      // },
      // {
      //   image: ka,
      //   title: "KA",
      //   type: "KA",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "JDB",
      // },

      //  {
      //   image: worldmatch,
      //   title: "WorldMatch",
      //   type: "WorldMatch",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "JDB",
      //   casinoType: "JDB-SLOT-012",
      // },
      
      {

        image: joker,
        title: "Joker",
        type: "Joker",
        key: "slot",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "JOKER",
        casinoType: "",
      },
      

      //   {
      //   image: cq9,
      //   title: "CQ9",
      //   type: "CQ9",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "FC",
      //   casinoType: "FC-SLOT-001",
      // },

      {
        image: netent,
        title: "NETENT",
        type: "NETENT",
        key: "slot",
        // gameTypeCheck: "platForm",
        gameType: "NETENT",
        platForm: "",
        casinoType: "",
      },

  {
        image: p8,
        title: "P8",
        type: "PLAYSTAR",
        key: "slot",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "PLAY8",
        casinoType: "",
      },

//  {
//         image: png,
//         title: "PNG",
//         type: "PNG",
//         key: "slot",
//         gameTypeCheck: "platForm",
//         gameType: "TABLE",
//         platForm: "JILI",
//         casinoType: "JILI-TABLE-004",
//       },

//  {
//         image: ladyLuck,
//         title: "Ladyluck",
//         type: "FastSpin",
//         key: "slot",
//         gameTypeCheck: "platForm",
//         gameType: "SLOT",
//         platForm: "JDB",
//         casinoType:"JDB-SLOT-079"
//       },
      
      {
        image: btg,
        title: "BTG",
        type: "btg",
        key: "slot",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "BTG",
      },

     
      {
        image: km,
        title: "KINGMAKER",
        type: "kingmaker",
        key: "slot",
        gameType: "SLOT",
        platForm: "KINGMAKER",
      },
     
      {
        image: pp,
        title: "PP",
        type: "pp",
        key: "slot",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "PP",
      },
      {
        image: dragonsoft,
        title: "DRAGOONSOFT",
        type: "dragoonsoft",
        key: "slot",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "DRAGOONSOFT",
      },

      // {
      //   image: evoplay,
      //   title: "EVOPLAY",
      //   type: "EVOPLAY",
      //   key: "slot",
      //   gameType: "egtGame",
      //   platForm: "EVO",
      //   gameTypeNew: "",
      //   casinoType: "LIVE CASINO",
      // },

      
      // {
      //   image: onetouch,
      //   title: "ONETOUCH",
      //   type: "ONETOUCH",
      //   key: "live",
      //   gameTypeCheck: "platForm",
      //   platForm: "ONETOUCH",
      // },

     
     
      {
        image: nlcLogo,
        title: "NLC",
        type: "NLC",
        key: "SLOT",
        // gameTypeCheck: "platForm",
        platForm: "NLC",
        gameType:"SLOT"
      },
     

     
      
    ],
  },
  {
    id: 3,
    title: "Table",
    key: "table",
    titlebn: "টেবিল",
    array: [
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "table",
        // gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "JILI",
      },
      {
        image: km,
        title: "KM",
        type: "kingmaker",
        key: "table",
        // gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "KINGMAKER",
      },

       {
        image: spribe,
        title: "SPRIBE",
        type: "SPRIBE",
        key: "table",
        // gameTypeCheck: "platForm",
        platForm: "SPRIBE",
        gameType: "",
        casinoType: "",
      },
      // ,{
      //     image: cq9,
      //     title: "CQ9",
      //     type: "CQ9",
      //     key: "table",
      //     gameTypeCheck: "platForm",
      //     gameType: "TABLE",
      //     platForm: "KINGMAKER",
      //     casinoType: "KINGMAKER-TABLE-006",
      //   },
      //   {
      //       image: rich88,
      //       title: "RICH88",
      //       type: "RICH88",
      //       key: "table",
      //       gameTypeCheck: "platForm",
      //       gameType: "SLOT",
      //     platForm: "JDB",
      //     casinoType:"JDB-SLOT-072"
      //     },
          
      
      //   {
      //   image: ka,
      //   title: "KA",
      //   type: "KA",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "TABLE",
      //   platForm: "KINGMAKER",
      //   casinoType: "KINGMAKER-TABLE-004",

      // },{
      //   image: worldmatch,
      //   title: "WorldMatch",
      //   type: "WorldMatch",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "TABLE",
      //   platForm: "KINGMAKER",
      //   casinoType: "KINGMAKER-TABLE-005",
      // },
      {
        image: pg,
        title: "PG",
        type: "pg",
        key: "TABLE",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "PG",
        gameType: "TABLE",
      },
      // {
      //   image: png,
      //   title: "PNG",
      //   type: "PNG",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "TABLE",
      //   platForm: "JILI",
      //   casinoType: "JILI-TABLE-004",
      // },
      // {
      //     image: bpoker,
      //     title: "Bpoker",
      //     type: "bpoker",
      //     key: "slot",
      //     gameTypeCheck: "platForm",
      //     gameType: "TABLE",
      //     platForm: "JILI",
      //   },
      // {
      //   image: jdb,
      //   title: "JDB",
      //   type: "jdb",
      //   key: "table",
      //   gameTypeCheck: "platForm",
      //   gameType: "TABLE",
      //   platForm: "JDB",
      // },
      // {
      //   image: rt,
      //   title: "REDTIGER",
      //   type: "rt",
      //   key: "table",
      //   gameTypeCheck: "platForm",
      //   gameType: "TABLE",
      //   platForm: "RT",
      // },
      {
        image: netent,
        title: "NETENT",
        type: "NETENT",
        key: "table",
        // gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "NETENT",
        casinoType: "",
      },
     

      
      // {
      //   image: ludo,
      //   title: "LUDO",
      //   type: "ludo",
      //   key: "table",
      //   gameTypeCheck: "platForm",
      //   platForm: "KINGMAKER",
      //   gameType: "TABLE",
      //   casinoType: "KM-TABLE-060",
      // },
      // {
      //   image: spribe,
      //   title: "SPRIBE",
      //   type: "SPRIBE",
      //   key: "table",
      //   gameTypeCheck: "platForm",
      //   gameType: "TABLE",
      //   platForm: "SPRIBE",
      //   casinoType: "SPRIBE-TABLE-001",
      // },
      // {
      //   image: royalgaming,
      //   title: "SPRIBE",
      //   type: "SPRIBE",
      //   key: "TABLE",
      //   gameTypeCheck: "platForm",
      //   platForm: "SPRIBE",
      //   gameType: "TABLE",
      // },
     
      // {
      //   image: bombaylive,
      //   title: "SPRIBE",
      //   type: "SPRIBE",
      //   key: "TABLE",
      //   gameTypeCheck: "platForm",
      //   platForm: "SPRIBE",
      //   gameType: "TABLE",
      // },
      
    ],
  },
  {
    id: 4,
    title: "Fishing",
    key: "fishing",
    type: "fishing",
    array: [
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "fishing",
        gameType: "FH",
        platForm: "JILI",
      },
      // {
      //   image: ka,
      //   title: "KA",
      //   type: "KA",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "JDB",
      //   casinoType: "JDB-SLOT-019",

      // },
      {
        image: jdb,
        title: "JDB",
        type: "jdb",
        key: "fishing",
        gameType: "FH",
        platForm: "JDB",
      },
      {
        image: fc,
        title: "FC",
        type: "fc",
        key: "fishing",
        // gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "FC",
      },
      
      
      // {
      //   image: ps,
      //   title: "PLAYSTAR",
      //   type: "PLAYSTAR",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "PP",
      // },{
      //   image: cq9,
      //   title: "CQ9",
      //   type: "CQ9",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "FH",
      //   platForm: "JDB",
      //   casinoType: "JDB-FISH-009",
      // },
      {
        image: joker,
        title: "Joker",
        type: "Joker",
        key: "fishing",
        // gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "JOKER",
        casinoType: "",
      },
      // {
      //   image: p8,
      //   title: "P8",
      //   type: "P8",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "FH",
      //   platForm: "JDB",
      //   casinoType: "JDB-FISH-009",
      // },
      {
        image: yesbingo,
        title: "YELLOWBAT",
        type: "yl",
        key: "fishing",
        // gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "YESBINGO",
      },
      // {
      //   image: betgames,
      //   title: "BG",
      //   type: "bg",
      //   key: "fishing",
      //   gameTypeCheck: "platForm",
      //   platForm: "BG",
      //   gameType: "LIVE",
      //   casinoType: "BG-LIVE-001",
      //   isLobbyTrue: true,
      // },
      

     
      {
        image: sg,
        title: "Spade",
        type: "spade",
        key: "fishing",
        // gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "SPADE",
      },
      
    ],
  },
  
  
  
  {
    id: 6,
    title: "Arcade",
    key: "arcade",
    titlebn: "স্পোর্টসবুক",
    array: [
      {
        image: jdb,
        title: "JDB",
        type: "jdb",
        key: "arcade",
        // gameTypeCheck: "platForm",
        gameType: "EGAME",
        platForm: "JDB",
      },
      {
        image: fc,
        title: "FC",
        type: "fc",
        key: "arcade",
        // gameTypeCheck: "platForm",
        gameType: "EGAME",
        platForm: "FC",
      },
      {
        image: spribe,
        title: "SPRIBE",
        type: "SPRIBE",
        key: "arcade",
        // gameTypeCheck: "platForm",
        gameType: "EGAME",
        platForm: "SPRIBE",
        casinoType: "",
      },
      // {
      //   image: ka,
      //   title: "KA",
      //   type: "KA",
      //   key: "arcade",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "JDB",
      //   casinoType: "JDB-SLOT-020",
      // },
      
      // {
      //   image: esport,
      //   title: "E1sports",
      //   type: "e1sports",
      //   key: "esports",
      //   gameTypeCheck: "platForm",
      //   gameType: "EGAME",
      //   platForm: "FC",
      // },
      // {
      //   image: cq9,
      //   title: "CQ9",
      //   type: "CQ9",
      //   key: "arcade",
      //   gameTypeCheck: "platForm",
      //   gameType: "FH",
      //   platForm: "JDB",
      //   casinoType: "JDB-FISH-009",
      // },
      // {
      //   image: rich88,
      //   title: "RICH88",
      //   type: "RICH88",
      //   key: "arcade",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "JDB",
      //   casinoType:"JDB-SLOT-072"
      // },
      // {
      //   image: pp,
      //   title: "PP",
      //   type: "pp",
      //   key: "egame",
      //   gameTypeCheck: "platForm",
      //   gameType: "egame",
      //   platForm: "PP",
      // },
      
      // {
      //   image: providernextspin,
      //   title: "NEXTSPIN",
      //   type: "FastSpin",
      //   key: "arcade",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "JDB",
      //   casinoType:"JDB-SLOT-032"
      // },
      // {
      //   image: yl,
      //   title: "YL",
      //   type: "yl",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "EGAME",
      //   platForm: "YL",
      // },
      // {
      //   image: sg,
      //   title: "Spade",
      //   type: "spade",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "EGAME",
      //   platForm: "SPADE",
      // },
      // {
      //   image: ps,
      //   title: "PLAYSTAR",
      //   type: "PLAYSTAR",
      //   key: "slot",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "PP",
      // },
      
    ],
  },
  {
    id: 7,
    title: "Lottery",
    key: "lottery",
    titlebn: "খেলাধুলা",
    array: [
      {
        image: Jili,
        title: "JILI",
        type: "jili",
        key: "lottery",
        // gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "JILI",
      },
      {
        image: km,
        title: "KM",
        type: "kingmaker",
        key: "lottery",
        // gameTypeCheck: "platForm",
        gameType: "TABLE",
        platForm: "KINGMAKER",
      },
       {
        image: joker,
        title: "Joker",
        type: "Joker",
        key: "lottery",
        // gameTypeCheck: "platForm",
        gameType: "SLOT",
        platForm: "JOKER",
        casinoType: "",
      },
      // {
      //   image: iconSportbook,
      //   title: "SABAVIRTUAL",
      //   type: "SABAVIRTUAL",
      //   key: "lottery",
      //   // gameTypeCheck: "platForm",
      //   platForm: "SABA",
      //   gameType: "",
      //   casinoType: "",
      // },
      // {
      //   image: number,
      //   title: "Money",
      //   type: "number",
      //   key: "table",
      //   gameTypeCheck: "platForm",
      //   gameType: "SLOT",
      //   platForm: "JILI",
      //   casinoType:"JILI-SLOT-029"
      // },
      
      // {
      //   image: cashRocket,
      //   title: "Rocket",
      //   type: "rocket",
      //   key: "table",
      //   gameTypeCheck: "platForm",
      //   gameType: "TABLE",
      //   platForm: "KINGMAKER",
      //   casinoType:"KM-TABLE-041"
      // },

      
     
      
      {
        image: yesbingo,
        title: "YellowBat",
        type: "yesbingo",
        key: "lottery",
        // gameTypeCheck: "platForm",
        gameType: "FH",
        platForm: "YESBINGO",
      },
      
    ],
  },
];

export const validationRules = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,15}$/,
  newPass: /^[a-zA-Z0-9]{8,15}$/,
  newPassMessage:
    "Password must contain uppercase and lowercase characters, numbers and must be minimum 8 character long (without special character).",
  passwordMessage:
    "Password must contain uppercase and lowercase characters, numbers, special character and must be minimum 8 character long.",
  characters: /^[a-zA-Z_ ]*$/,
  numbers: /^[0-9]*$/,
  removeWhitespace: /^[a-zA-Z0-9]+$/,
  numberNew: /^[0-9]*$/,
  numberWithDot: /^\d*(\.\d{0,10})?$/,
};
export const preventMaxInput = (e) => {
  e.target.value = e.target.value.trimStart();
  e.target.value = e.target.value.replace(/  +/g, " ");
};
export const AmountArray = [
  { id: 1, amount: 300 },
  { id: 2, amount: 500 },
  { id: 3, amount: 1000 },
  { id: 4, amount: 5000 },
  { id: 5, amount: 1000 },
  { id: 6, amount: 15000 },
  { id: 7, amount: 20000 },
  { id: 8, amount: 25000 },
];
export const sidebarMenuData = [{
    id: 1,
    icons: '#nav-hot_0b8ae9aa',
    title: "Hot Games",
    type: "hotgame",
    titlebn: "গরম খেল",
  },
{
    id: 1,
    icons: "#nav-fav_fc2e4b64",
    title: "Favorites",
    type: "hotgame",
    titlebn: "গরম খেল",
  },
   {
    id: 3,
    icons: "#nav-slot_86963cca",
    title: "Slot",
    titlebn: "স্লট",
    type: "slot",
    position: "translate(-1px, -7px)",
    subCategory:"JILI"
  },
    {
    id: 2,
    icons: "#nav-live_319534a6",
    title: "Live Casino",
    titlebn: "ক্যাসিনো",
    type: "live",
    position: "translate(-5px, 2px)",
    subCategory:"SEXY"
  },
   {
    id: 5,
    icons: "#nav-fish_59aa682d",
    title: "Fishing",
    titlebn: "মাছ ধরা",
    type: "fishing",
    position:'translate(-4px, -5px)',
     subCategory:"JILI"
  },
  {
    id: 1,
    icons: "#nav-sport_e2fbf0a4",
    title: "Sports",
    type: "sports",
    titlebn: "স্পোর্টস",
    position: "translate(5px, -7px)",
  },


  // {
  //   id: 5,
  //   icons: "#nav-esport_f6ddcc86",
  //   title: "Arcade",
  //   type: "arcade",
  //   titlebn: "স্পোর্টসবুক",
  //    subCategory:"JDB"
  // },

  // {
  //   id: 6,
  //   icons: "#nav-lottery_79b60d1b",
  //   title: "Lottery",
  //   titlebn: "ভার্চুয়াল",
  //   type: "lottery",
  //   position: "translate(-7px, 9px)",
  //    subCategory:"KINGMAKER"
  // },
 

    {
    id: 2,
    icons: "#nav-pvp_c10cd04b",
    title: "Poker",
    titlebn: "ক্যাসিনো",
    type: "poker",
    position: "translate(-5px, 2px)",
    subCategory:"JILI"
  },
];
export const sidebarMenuData2 = [{
    id: 1,
    icons: '#invite-friend_7b631ba4',
    title: "Invite friends",
    titlebn: "গরম খেল",
    link:"/inviteFriends"
  },

   {
    id: 3,
    icons: "#promotion_58045fa8",
    title: "Promotion",
    titlebn: "স্লট",
     link:"/promotions"
  },
    {
    id: 2,
    icons: "#reward-center_0cea6ab6",
    title: "Reward Center",
    titlebn: "ক্যাসিনো",
  link:"/rewardCenter"
  },
  //  {
  //   id: 5,
  //   icons: "#rebate_e34c53fd",
  //   title: "Manual Rebate",
  //   titlebn: "মাছ ধরা",
  //    link:"/rewardCenter"
  // },
  {
    id: 1,
    icons: "#vip_4f5bd5eb",
    title: "VIP",
     link:"/vip"
  },

  {
    id: 5,
    icons: "#mission_5ecd484e",
    title: "Mission",
      link:"#"
  },
  {
    id: 5,
    icons: "#language",
    title: "Language",
      link:"#"
  },

  {
    id: 6,
    icons: "#download_16a91adc",
    title: "Download",
    titlebn: "ভার্চুয়াল",
   link:"#"
  },
   {
    id: 6,
    icons: "#service_d7a3f200",
    title: "Customer Service",
    titlebn: "ভার্চুয়াল",
    link:"/customer-support"
   }
  
];

export const categoryArray = [
  { type: 1, name: "Market" },
  { type: 3, name: "Bookmakers" },
  { type: 5, name: "ManualOdds" },
  { type: 10, name: "Win Toss" },
  { type: 2, name: "Session" },
  { type: 6, name: "Over by Over Session Market" },
  { type: 7, name: "Player" },
  { type: 9, name: "Wicket" },
  { type: 11, name: "Bowler Session" },
  { type: 8, name: "Last Digit ODD" },
  { type: 4, name: "LineMarket" },
  { type: 14, name: "Premium ODDs" },
];

export function toFixedWithoutRounding(num, decimals = 2) {
  // Convert to string
  if (Math.abs(Number(num)) > 0) {
    const str = num?.toString();

    // Find decimal point position
    const decimalIndex = str?.indexOf(".");

    // If there's no decimal, add zeros
    if (decimalIndex === -1) {
      return str + "." + "0".repeat(decimals);
    }

    // Extract integer + desired decimal digits
    const fixed = str?.substring(0, decimalIndex + decimals + 1);

    // If decimal digits are less, pad with zeros
    const decimalPart = fixed?.split(".")[1] || "";
    return fixed + "0".repeat(decimals - decimalPart?.length);
  } else {
    return 0.0;
  }
}
export const formatWithCommas = (num) => {
  if (num === null || num === undefined || isNaN(num)) return "0";
  return Number(num).toLocaleString("en-IN");
};
export const bankType = [
  { _id: 1, bank_name: "bkash" },
   { _id: 2, bank_name: "nagad" },
    { _id: 3, bank_name: "rocket" },
  
];